
<div class="w-full bg-[#001847] h-[370px] relative" id="mask-image">
    <div class="container">
<div class="w-full text-center relative  float-end mt-5 h-[360px]">
        <h1 class="text-white fw-medium fs-3 m-0 pb-2 mb-1   mt-5">
            {{reviewsCount}}
        </h1>
        <h2 class="text-white fs-1.6">نفر بهترین نکات سفرشون رو به اشتراک گذاشتن</h2>
    <img src="/assets/images/header-reviews-city.svg" width="500" height="250" alt="image"
        class="full-img d-block absolute left-0 bottom-0" fetchpriority="high">
</div>
</div>
</div>

<div class="container">
    
   
    <nav>
        <ol class="breadcrumb-wrapper flex-wrap flex items-center gap-2 my-5">
            <li [ngClass]="last ? 'pointer-events-none' : 'cursor-pointer'"
                *ngFor="let bread of breadcrumb; let last = last; let index = index;let first = first">
                <ng-container *ngIf="!last && bread.Url">
                    <a [href]="first ? '/' : tolowerUrl(bread.Url)">
                        {{ bread.Name }}
                    </a>
                </ng-container>
                <ng-container *ngIf="last">
                    <span class=""> {{ bread.Name }} </span>
                </ng-container>
    
            </li>
        </ol>
    </nav>
    <div id="customMasonry">
    <div class="grid lg:grid-cols-4 grid-cols-1 gap-4">
            <div *ngFor="let colItem of [].constructor(columnCount) ;let colIndex = index">
                <ng-container *ngFor="let item of reviewsOfCity; let dataItemIndex = index">
                    <ng-container *ngIf="dataItemIndex % columnCount === colIndex">
                        <iho-masonry-item [reviewsCount]="reviewsCount" [data]="item" [isTruncate]="false"></iho-masonry-item>
                    </ng-container>
                </ng-container>
            </div>
        </div></div>
    </div>